import React, { useRef, useEffect } from 'react';

import styles from './styles.module.scss';

export enum CHECKBOX_STATE {
  CHECKED = 'checked',
  UNCHECKED = 'unchecked',
  INDETERMINATE = 'indeterminate',
}

export interface ICheckbox {
  label?: string;
  value?: CHECKBOX_STATE;
  onChange: React.ChangeEventHandler;
  disabled?: boolean;
}

const Checkbox = ({ label, value = CHECKBOX_STATE.UNCHECKED, onChange, disabled = false }: ICheckbox) => {
  const checkboxRef = useRef<HTMLInputElement | null>(null);

  const handleLabelClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (checkboxRef.current) {
      if (value === CHECKBOX_STATE.CHECKED) {
        checkboxRef.current.checked = true;
        checkboxRef.current.indeterminate = false;
      } else if (value === CHECKBOX_STATE.UNCHECKED) {
        checkboxRef.current.checked = false;
        checkboxRef.current.indeterminate = false;
      } else if (value === CHECKBOX_STATE.INDETERMINATE) {
        checkboxRef.current.checked = false;
        checkboxRef.current.indeterminate = true;
      }
    }
  }, [value]);

  return (
    <label className={`${styles.container} ${disabled ? styles.disabled : ''}`} onClick={handleLabelClick}>
      <input ref={checkboxRef} type="checkbox" onChange={onChange} disabled={disabled} />
      <svg width="16" height="16" viewBox="0 0 16 16">
        {value == CHECKBOX_STATE.CHECKED ? (
          <>
            <path
              d="M2.667 0h10.666A2.667 2.667 0 0 1 16 2.667v10.666A2.667 2.667 0 0 1 13.333 16H2.667A2.667 2.667 0 0 1 0 13.333V2.667A2.667 2.667 0 0 1 2.667 0Z"
              fill="currentColor"
            />
            <path
              d="M13.807 3.91a1 1 0 0 1-.007 1.405l-6.955 6.8c-.39.38-1.011.38-1.4 0L2.201 8.942a1 1 0 0 1-.098-1.32l.082-.095A1 1 0 0 1 3.6 7.512L6.145 10l6.256-6.115a1.001 1.001 0 0 1 1.406.025Z"
              fill="#FFF"
              className={styles.icon}
            />
          </>
        ) : value === CHECKBOX_STATE.INDETERMINATE ? (
          <>
            <path
              d="M2.667 0h10.666A2.667 2.667 0 0 1 16 2.667v10.666A2.667 2.667 0 0 1 13.333 16H2.667A2.667 2.667 0 0 1 0 13.333V2.667A2.667 2.667 0 0 1 2.667 0Z"
              fill="currentColor"
            />
            <path d="M3 9a1 1 0 1 1 0-2h10a1 1 0 0 1 0 2H3Z" fill="#FFF" className={styles.icon} />
          </>
        ) : (
          <path
            d="M13.333 0H2.667A2.667 2.667 0 0 0 0 2.667v10.666A2.667 2.667 0 0 0 2.667 16h10.666A2.667 2.667 0 0 0 16 13.333V2.667A2.667 2.667 0 0 0 13.333 0Zm0 2c.368 0 .667.299.667.667v10.666a.667.667 0 0 1-.667.667H2.667A.667.667 0 0 1 2 13.333V2.667C2 2.299 2.299 2 2.667 2h10.666Z"
            fill="currentColor"
          />
        )}
      </svg>
      {label && <span>{label}</span>}
    </label>
  );
};

export default Checkbox;
